import type { ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import { useAuthStore } from 'src/stores/auth-store';
import { useAuth } from 'src/features/auth/hooks/use-auth';
import { showNotification } from 'src/lib/notifications';

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAuthenticated } = useAuth();
  const roles = useAuthStore((state) => state.roles);

  // Check if user is authenticated and has admin role
  const isAdmin = roles.includes('Admin');

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" />;
  }

  if (!isAdmin) {
    // Show unauthorized message and redirect to home
    showNotification('You do not have permission to access this page', 'error');
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}
